import { LoginFlow } from './types';
import { AuthProvider } from './AuthProvider';
// Re-export LoginFlow for use in the bundle
export { LoginFlow };
export class PasswiserLoginsSDK {
    constructor(config) {
        this.authProvider = new AuthProvider(config);
    }
    async login(flow = LoginFlow.SIWE) {
        return this.authProvider.login(flow);
    }
    async handleOAuthCallback() {
        return this.authProvider.handleOAuthCallback();
    }
}
